import { render, staticRenderFns } from "./BuscarDocFiscalDetalhes.vue?vue&type=template&id=d82125a6"
import script from "./BuscarDocFiscalDetalhes.vue?vue&type=script&lang=js"
export * from "./BuscarDocFiscalDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports